import React from 'react';

const TaxSecureSubmissionCard = () => {
  return (
    <div className="d-flex gap-3 mb-4 notice_card">
      <div>
        <i className="fa-solid fa-shield-halved"></i>
      </div>
      <div className="w-full">
        <h4>Secure Submission</h4>
        <p>
          Your information is encrypted and transmitted securely to the IRS.
          We do not retain any personal data after submission. You will receive
          a 1099 form at the end of each tax year.
        </p>
      </div>
    </div>
  );
};

export default TaxSecureSubmissionCard;
